const formatName = ({ firstName, lastName }: { firstName?: string, lastName?: string }): string =>
	[firstName, lastName].filter(a => a).join(" ")

export default formatName